
import {Popup} from "@maidi/common";
import OrgSelector from "@/views/components/workflow/selector/org-selector";



export class Selector {
   static async $pc() {
    const selector = await import("@maidi/libs.pc/libs/library/selector");
    return selector.Selector;
  }

  static async Model() {
      const selector = await this.$pc();
      return selector.Model();

  }
  static async OrgShow(value,multi=false) {
    let selected = await Popup(OrgSelector, {
      value,
      multi
    });
    selected = selected || [];
    return [].concat(selected).map((item) => {
      return {
        id: item.id,
        name: item.name
      }
    });
  }
}
